// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "./controllers"

// Enables Active Storage direct uploads: file inputs marked `direct_upload: true` upload
// straight to the storage service (DigitalOcean Spaces in staging/prod) via a presigned PUT,
// so large assets never pass through the Rails process.
ActiveStorage.start()
